import React from 'react';
import ScoreRankLabel from 'components/ScoreRankLabel';
import {ArrowRightIcon, PlusIcon, MinusIcon} from '@heroicons/react/20/solid';
import {ProspectPoolTotalScoreRankHistory} from 'api';

interface Props {
  history: ProspectPoolTotalScoreRankHistory;
}

export const ScoreChangeDisplay = ({history}: Props) => {
  const scoreDiff = (history.toScore || 0) - (history.fromScore || 0);
  const hasScoreChange =
    history.fromRank && history.toRank && history.fromRank !== history.toRank;
  const ScoreDiffBadge = () => {
    if (scoreDiff === 0) return null;

    return (
      <span
        className={`font-bold flex items-center ${
          scoreDiff > 0
            ? 'text-[var(--score-green-foreground)]'
            : 'text-[var(--score-red-foreground)]'
        }`}>
        {scoreDiff > 0 ? (
          <PlusIcon className="h-3" />
        ) : (
          <MinusIcon className="h-3" />
        )}
        {Math.abs(scoreDiff)}
      </span>
    );
  };

  if (hasScoreChange) {
    return (
      <div className="flex items-center gap-2">
        <ScoreRankLabel scoreRank={history.fromRank?.toUpperCase()} />
        <ArrowRightIcon className="h-4 text-foreground-light" />
        <ScoreRankLabel scoreRank={history.toRank?.toUpperCase()} />
        <ScoreDiffBadge />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <ScoreRankLabel scoreRank={history.toRank?.toUpperCase()} />
      <ScoreDiffBadge />
    </div>
  );
};
